"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const featureItems = [{
  id: "01",
  tag: "OUR WORK",
  title: "施工實績",
  description: "精選地材案例\n展現空間質感",
  image: "https://hent.services/wp-content/uploads/2026/05/OUR-WORK.webp",
  link: "/%e4%bd%9c%e5%93%81%e8%88%87%e6%9c%8d%e5%8b%99-project-services/",
  delay: "duration-1000 delay-0"
}, {
  id: "02",
  tag: "DISCOVERY",
  title: "地板怎麼選?",
  description: "掌握地材趨勢\n與最新業界動態",
  image: "https://hent.services/wp-content/uploads/2026/05/DISCOVERY.webp",
  link: "/knowledge/",
  delay: "duration-1000 delay-300"
}, {
  id: "03",
  tag: "CONTACT US",
  title: "聯繫我們",
  description: "專業地材服務\n隨時為您解答需求",
  image: "https://hent.services/wp-content/uploads/2026/05/CONTACT-US.webp",
  link: "/%e8%81%af%e7%b5%a1%e6%88%91%e5%80%91-contact/",
  delay: "duration-1000 delay-500"
}];
export default function FeatureStepGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section ref={ref} className="relative bg-secondary py-24 md:py-48 overflow-hidden">
      {}
      <div className="absolute top-20 left-10 text-[15rem] font-serif font-bold text-foreground/5 select-none pointer-events-none leading-none">
        Natural
      </div>
      <div className="absolute bottom-20 right-10 text-[12rem] font-serif font-bold text-foreground/5 select-none pointer-events-none leading-none">
        Living
      </div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        
        {}
     <div className={cn("mb-24 md:mb-40 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
  <h4 className="text-primary font-sans tracking-[0.4em] uppercase text-xs mb-5">
    Premium Service
  </h4>

  {/* 標題與底色塊容器 */}
  <div className="relative mb-8 w-fit mx-auto">
    <h2 className="text-[1.5rem] sm:text-3xl md:text-5xl font-hk-regular text-foreground tracking-tight relative z-10 px-1 whitespace-nowrap">
      帶你一步步更了解地板
    </h2>
    {/* 奶茶色底色塊效果 */}
    <div className="absolute left-0 bottom-1 w-full h-3 md:h-5 bg-[#D9C5B2]/80 -z-10" />
  </div>

  {/* 註：原本的分割線 div 已移除，避免視覺混亂 */}

  <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed text-sm md:text-base font-sans font-light">
    我們專注於地材鋪設與創新，以卓越技術與專業服務滿足多樣設計需求。
  </p>
</div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-20 md:gap-y-0 md:gap-x-12 lg:gap-x-20 relative">
          {featureItems.map((item, index) => <div key={item.id} data-index={index} className={cn("group relative flex flex-col fill-mode-both transition-all ease-out", isVisible ? `animate-in fade-in slide-in-from-bottom-16 ${item.delay}` : "opacity-0 translate-y-20", index === 0 && "md:mt-32", index === 1 && "md:mt-16", index === 2 && "md:mt-0")}>
              {}
              <div className="absolute -inset-3 border border-primary/10 rounded-sm opacity-0 group-hover:opacity-100 group-hover:-translate-y-2 group-hover:translate-x-2 transition-all duration-500 pointer-events-none" />

              <Link to={item.link} className="block relative overflow-hidden aspect-[4/5.8] bg-white shadow-md group-hover:shadow-xl transition-all duration-700">
                
                {}
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-110" />
                
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/20 to-transparent transition-opacity duration-500 group-hover:opacity-60" />
                
                {}
                <div className="absolute inset-0 p-10 flex flex-col items-center justify-center text-center text-white z-20">
                  {/* <span className="text-5xl md:text-6xl font-serif font-light mb-4 opacity-30 italic leading-none">{item.id}</span> */}
                  <span className="text-[10px] tracking-[0.5em] uppercase mb-8 opacity-60 font-sans">/ {item.tag} /</span>
                  
                  <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6 tracking-widest leading-tight">
                    {item.title}
                  </h3>
                  
                  <p className="text-xs md:text-sm font-sans leading-relaxed opacity-0 group-hover:opacity-100 transition-all duration-500 mb-10 whitespace-pre-line font-light translate-y-4 group-hover:translate-y-0">
                    {item.description}
                  </p>

                  <div className="mt-auto flex items-center gap-2 text-[10px] font-bold tracking-[0.4em] uppercase group-hover:gap-5 transition-all">
                    More Detail <ArrowRight className="size-3 text-primary" />
                  </div>
                </div>

                <div className="absolute inset-6 border border-white/20 pointer-events-none group-hover:inset-8 transition-all duration-700 z-30" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}